'use client';

import { AnimatePresence as FMAnimatePresence } from 'framer-motion';

export const AnimatePresence = FMAnimatePresence;
